import { Alert, Inline, Paragraph } from "@george-labs.com/design-system"
import { EcsaBranchDTO } from "@smartx/mikro-vt-client-api"
import dayjs from "../../utils/dayjs"
import { useTranslation } from "react-i18next"

interface IOpeningDataProps {
  branch: EcsaBranchDTO
}

const OpeningData: React.FC<IOpeningDataProps> = ({ branch }) => {
  const { t } = useTranslation()

  if (!branch?.openingDatas?.length) {
    return
  }

  return (
    <Alert
      variant={Alert.VARIANT.INFO}
      heading={t("offers.appointment.openings")}
      key={`openings-${branch.id}`}
    >
      {branch.openingDatas?.map((od) => (
        <Paragraph key={`${branch.id}-${od.day}`}>
          <Inline>{t(`offers.appointment.openings.${od.day}`)} </Inline>
          {dayjs(od.open).format("HH:mm")} - {dayjs(od.close).format("HH:mm")}
        </Paragraph>
      ))}
    </Alert>
  )
}

export default OpeningData
